import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Row, Col, Form, Input, Modal, message, Select } from 'antd';

const CarHouseForm = ({
  open,
  onCancel,
  selectedCarHouse,
  addCarHouse,
  editCarHouse,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (selectedCarHouse) {
      form.setFieldsValue(selectedCarHouse);
    } else {
      form.resetFields();
    }
  }, [form, selectedCarHouse]);

  const onSubmit = async (values) => {
    //let address = values.address + ', ' + values.city + ', ' + values.country;
    let supportEmails = [];
    supportEmails.push(values.email);
    let body = {
      name: values.name,
      phone: values.phone,
      address: values.address || undefined,
      supportEmails: supportEmails,
      //paymentType: values.paymentType || undefined,
    };
    if (selectedCarHouse) {
      let editBody = {};
      Object.keys(selectedCarHouse).forEach((key) => {
        if (key in values) {
          if (selectedCarHouse[key] !== values[key]) {
            if (key !== 'email') {
              editBody[key] = values[key] || null;
            }
          }
        }
        if (key === 'email') {
          supportEmails.push(values.email);
          editBody['supportEmails'] = supportEmails;
        }
      });

      if (
        Object.keys(editBody).length === 0 &&
        editBody.constructor === Object
      ) {
        return;
      }
      editCarHouse(editBody);
    } else {
      addCarHouse(body);
    }
  };

  return (
    <Modal
      open={open}
      forceRender
      title={
        selectedCarHouse
          ? t('carHouses.editCarHouse')
          : t('carHouses.addCarHouse')
      }
      okText={selectedCarHouse ? t('common.edit') : t('common.add')}
      cancelText={t('common.cancel')}
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onSubmit(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
            message.error('Something wrong');
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="form"
        initialValues={selectedCarHouse}
      >
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="name"
              label={t('common.name')}
              rules={[
                {
                  required: true,
                  message: t('form.validationMessages.requiredField', {
                    field: t('common.name'),
                  }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="email"
              label={t('common.email')}
              validateTrigger={['onBlur']}
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: t('form.validationMessages.requiredField', {
                    field: t('common.email'),
                  }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item name="address" label={t('common.address')}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            {
              <Form.Item name="phone" label={t('common.phone')}>
                <Input />
              </Form.Item>
            }
          </Col>
          {/*  <Col xs={24} sm={12}>
            <Form.Item name="paymentType" label="Payment Type">
              <Select allowClear placeholder="Select payment type">
                <Select.Option value="prepaid">Prepaid</Select.Option>
                <Select.Option value="postpaid">Postpaid</Select.Option>
                <Select.Option value="monthly">Monthly</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="country"
              label="Country"
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="city"
              label="City"
            >
              <Input />
            </Form.Item>
          </Col>*/}
        </Row>
      </Form>
    </Modal>
  );
};

export default CarHouseForm;
